module.exports = __webpack_public_path__ + "static/media/py.d5409b74.svg";